<template>
	<div>
		<div class="mainTitle text-center mt-4 mb-3">
			<h3 class="mb-4"> {{$t('tryAgain')}}</h3>
		</div>  
	    <div class="CustomBlockWidth text-center acPassword whitebox p-4">  
    		<div class="reapir mb-3 d-flex align-items-center justify-content-center">
    			<flip-countdown :deadline="test_finish_date"></flip-countdown>
    		</div> 
			<label class="failedtext mb-3" v-html="$t('failedTestMsz1')"></label>
            <router-link :to="'/create-demo-account'" class="btn_xs grd_btn mr-2">
				<img src="../../../../static/fxView/images/demo_ico.svg" alt="Demo Account">
				{{$t('createDemoAccount')}}
			</router-link>
	    </div> 
	</div>
</template>
<script>
	import FlipCountdown from 'vue2-flip-countdown'
	import { fxViewMixins } from '@/plugins/fxView'
	import moment from 'moment'
	export default {
		name: 'Countdown',
		mixins: [fxViewMixins],
		components: { FlipCountdown },
		data() {
            return {test_finish_date : ''}
		},
		created(){
			this.test_finish_date = this.get_user.profile.test_date
			this.test_finish_date = moment(this.test_finish_date).add(7, 'days').format('YYYY-MM-DD hh:mm:ss');
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/unauthorized/failedTest.vue